import React from 'react';

const textMaskFunc = (
  ref: ((instance: HTMLInputElement | null) => void) | React.MutableRefObject<HTMLInputElement | null> | null,
) => {
  const connectRef = (textMaskRef: (inputElement: HTMLElement) => void) => {
    return (node: HTMLInputElement) => {
      if (node) {
        textMaskRef(node);
        if (typeof ref === 'function') {
          ref(node);
        }
      }
    };
  };

  return [connectRef];
};

export default textMaskFunc;
